import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Lob, Period } from '@cmi/shared/models';
import { Company } from '@cmi/store/admin/company';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class CompanyHttpService {
  private baseUrl = `${environment.cmiApiUri}`;

  constructor(private httpClient: HttpClient) {}

  getCompany(companyId: number): Observable<Company> {
    const url = `${this.baseUrl}/api/admin/company/${companyId}`;

    return this.httpClient.get<Company>(url, { responseType: 'json' });
  }

  getCompanyLogo(filename: string): Observable<Blob> {
    const url = `${this.baseUrl}/api/file/logo/${filename}`;

    return this.httpClient.get(url, { responseType: 'blob' });
  }

  getPeriods(): Observable<Period[]> {
    const url = `${this.baseUrl}/api/admin/quarters`;

    return this.httpClient.get<Period[]>(url, { responseType: 'json' });
  }

  getLobs(): Observable<Lob[]> {
    const url = `${this.baseUrl}/api/dashboard/lobs`; // TODO may require dedicated endpoint

    return this.httpClient.get<Lob[]>(url, { responseType: 'json' });
  }

  saveCompany(
    companyId: number | undefined,
    company: Company,
    file: File | null
  ): Observable<Company> {
    const url = `${this.baseUrl}/api/admin/company`;

    const formData = new FormData();
    formData.append('company.Id', company.id.toString());
    formData.append('company.Name', company.name);
    formData.append('company.IsEnabled', company.isEnabled ? 'true' : 'false');

    if (company.pdfCoverTitle) {
      formData.append('company.PdfCoverTitle', company.pdfCoverTitle);
    }
    if (company.logoPath) {
      formData.append('company.LogoPath', company.logoPath);
    }
    if (company.templateTypeId) {
      formData.append('company.TemplateTypeId', company.templateTypeId.toString());
    }
    if (company.startPeriodId) {
      formData.append('company.StartPeriodId', company.startPeriodId.toString());
    }
    if (company.endPeriodId) {
      formData.append('company.EndPeriodId', company.endPeriodId.toString());
    }

    (company.companySubLobs ?? []).forEach((subLob, index) => {
      formData.append(`company.CompanySubLobs[${index}]`, subLob.toString());
    });

    if (file) {
      formData.append('files', file, file.name);
    }

    return companyId
      ? this.httpClient.put<Company>(url, formData)
      : this.httpClient.post<Company>(url, formData);
  }
}
